<template>
  <label class="switch" :class="{disabled: disabled}">
    <input type="checkbox" :disabled="disabled" :checked="checked" v-model="inputVal" />
    <span class="slider round"></span>
  </label>
</template>

<script>
export default {
  name: "MoveBtn",
  props:{
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
}


.switch.disabled{
  opacity: 0.6;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(---secondary-color-dark);
  -webkit-transition: .4s;
  transition: .4s;
}

.disabled .slider{
  cursor: auto !important;
  background-color: var(---secondary-color-dark);
}


.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 1px;
  bottom: 1px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(18px);
  -ms-transform: translateX(18px);
  transform: translateX(18px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 12px;
  border-color: var(---secondary-color-dark)
}

.slider.round:before {
  border-radius: 50%;
  border-color: var(---secondary-color-dark)
}
</style>
